import SentryErrorBoundary from '@components/common/sentry-error-boundary';

import Coupons from './components/coupons';

const CouponsComponent = () => {
  return (
    <SentryErrorBoundary>
      <Coupons />
    </SentryErrorBoundary>
  );
};

export default CouponsComponent;
